export function getDeviceType() {
  const ua = navigator.userAgent.toLowerCase()
  const width = window.screen.width
  const height = window.screen.height

  // ⌚️ 尝试识别常见的手表特征
  const isWatchUA = /watch|wear|sm-r\d+/.test(ua)
  const isWatchScreen = width <= 400 && height <= 400 // 小屏幕手表

  if (isWatchUA || isWatchScreen) {
    return 'watch'
  }

  // 📱 手机
  const isMobileUA = /iphone|ipod|android.*mobile|windows phone/.test(ua)
  if (isMobileUA) {
    return 'phone'
  }

  // 💻 其他设备，如平板或桌面
  return 'other'
}